import { theme } from 'config'
import styled from 'styled-components'

export const DataGridStyles = styled.div`
  .MuiDataGrid-root {
    border-radius: 0;
    border: none;
    font-size: 1.6rem;

    .MuiDataGrid-row {
      background-color: white;
      transition: background-color 0.2s ease;
      min-height: 6rem;

      :hover {
        background-color: #e9e9e2;
        cursor: pointer;
      }

      .MuiDataGrid-cell {
        border-bottom: 0.5rem solid;
        border-color: #f4f4f0;

        :focus-within {
          outline: none;
        }
      }
    }
  }

  .actionHeader {
    padding-right: 2.5rem;
  }

  .actionHeader,
  .columnHeader {
    height: 3rem;
  }

  .MuiDataGrid-columnHeaders {
    border-bottom: none;
  }

  .MuiDataGrid-footerContainer {
    border-top: none;
  }

  .MuiDataGrid-iconSeparator {
    visibility: hidden;
  }
`
